<script setup lang="ts">
import { watch } from "vue";
import { useRoute } from "vue-router";
import NavBar from "./NavBar.vue";
import Footer from "./Footer.vue";

const route = useRoute();

function trackPageView(path: string) {
  if (typeof window === "undefined") return;
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (isLocalhost) return;
  try {
    const base = (window as any).__API_BASE__ || localStorage.getItem("cpa_api_base") || "";
    fetch(`${base}/api/admin/access/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path }),
    }).catch(() => {});
  } catch {
    // ignore
  }
}

watch(
  () => route.path,
  (path) => {
    trackPageView(path);
  },
  { immediate: true }
);
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <template v-if="route.path !== '/admin'">
      <NavBar />
      <main class="flex-1 min-h-0">
        <router-view />
      </main>
      <Footer />
    </template>
    <template v-else>
      <main class="flex-1">
        <router-view />
      </main>
    </template>
  </div>
</template>
